import { render, staticRenderFns } from "./ChamadosGuiche.vue?vue&type=template&id=b65b81d8&scoped=true&"
import script from "./ChamadosGuiche.vue?vue&type=script&lang=js&"
export * from "./ChamadosGuiche.vue?vue&type=script&lang=js&"
import style0 from "./ChamadosGuiche.vue?vue&type=style&index=0&id=b65b81d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65b81d8",
  null
  
)

export default component.exports